var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconClipboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23.3333 5.83594C26.5052 5.85344 28.2231 5.9949 29.3431 7.1149C30.625 8.39677 30.625 10.4589 30.625 14.583V23.333C30.625 27.4586 30.625 29.5207 29.3431 30.8026C28.0627 32.083 25.9992 32.083 21.875 32.083H13.125C9.00083 32.083 6.93729 32.083 5.65687 30.8026C4.375 29.5193 4.375 27.4586 4.375 23.333V14.583C4.375 10.4589 4.375 8.39677 5.65687 7.1149C6.77688 5.9949 8.49479 5.85344 11.6667 5.83594",
    stroke: "#367FFF",
    strokeWidth: 2.1875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6663 20.4167H23.333M10.208 15.3125H24.7913M13.1247 25.5208H21.8747",
    stroke: "#367FFF",
    strokeWidth: 2.1875,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.667 5.10547C11.667 4.52531 11.8975 3.96891 12.3077 3.55867C12.7179 3.14844 13.2743 2.91797 13.8545 2.91797H21.1462C21.7263 2.91797 22.2827 3.14844 22.693 3.55867C23.1032 3.96891 23.3337 4.52531 23.3337 5.10547V6.5638C23.3337 7.14396 23.1032 7.70036 22.693 8.1106C22.2827 8.52083 21.7263 8.7513 21.1462 8.7513H13.8545C13.2743 8.7513 12.7179 8.52083 12.3077 8.1106C11.8975 7.70036 11.667 7.14396 11.667 6.5638V5.10547Z",
    stroke: "#367FFF",
    strokeWidth: 2.1875
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClipboard);
export default __webpack_public_path__ + "static/media/icon-clipboard.b2f17f0cc96375b469beadd15c8e8e2d.svg";
export { ForwardRef as ReactComponent };